// extracted by mini-css-extract-plugin
export default {"productLine":"ProductLine_productLine__Ysgi7","additional":"ProductLine_additional__bxm3C"};